import Window from './components/Window'

function App() {
  return (
    <div>
      <Window title="COUNTER"/>
    </div>
  );
}

export default App;
